import {DataProvider} from "@refinedev/core"

const fetchInstance = async (url: string, method: string = 'get', body: any = null) => {
    const response = await fetch(url, {
        credentials: 'include',
        headers: {'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}`},
        method: method,
        body: body && JSON.stringify(body)
    })
    if (!response.ok) {
        throw new Error(`Response status: ${response.status}`)
    }
    return await response.json()
}

export const dataProvider = (apiUrl: string): DataProvider => ({
    getApiUrl: () => apiUrl,
    create: async ({resource, variables}) => {
        return {data: await fetchInstance(`${apiUrl}/${resource}`, 'post', variables)}
    },
    getOne: async ({resource, id}) => {
        return {data: await fetchInstance(`${apiUrl}/${resource}/${id}`)}
    },
    getList: async ({resource, filters, meta}): Promise<any> => {
        try {
            const data = await fetchInstance(`${apiUrl}/${resource}`)
            return {data: meta?.resourceName ? data[meta.resourceName] : data}
        } catch (e) {
            return {data: []};
        }
    },
    update: async ({resource, id, variables}) => {
        return {data: await fetchInstance(`${apiUrl}/${resource}/${id}`, 'put', variables)}
    },
    deleteOne: async ({resource, id, variables}) => {
        return {data: await fetchInstance(`${apiUrl}/${resource}/${id}`, 'delete', variables)}
    }
})